<div class="page" id="report-def-page">

  <div class="action-bar dark-bg with-tabs">
    <div class="title">Reporte: {rpt && rpt.title || '?'}</div>

    <div class="tabs">
      <span class="tabs-breadcrumbs">
        <span class="account-full-name">Cuenta</span> /
        <span class="profile-full-name">Persona</span> /
        Reporte
      </span>
    </div>

    <div class="actions-set">
      <!-- svelte-ignore a11y-missing-content -->
      <a 
        class="action-btn back" 
        href="#back" 
        title="Cancelar"
        ></a>
      <!-- svelte-ignore a11y-missing-content -->
      <a 
        class="action-btn done" 
        href="#" 
        title="Guardar y Salir"
        on:click={() => saveIt('exit')}
        ></a>
      &nbsp;|&nbsp;
      <!-- svelte-ignore a11y-missing-content -->
      <a 
        class="action-btn delete" 
        href="#"
        title="Eliminar"
        on:click={() => deleteIt('exit')}
        ></a>
      <a 
        class="action-btn sos" 
        href="#"
        >SOS</a>
    </div>

  </div>
  <div class="content">
    <div class="container">
      <div class="section" id="reporte">

        {#if isCurrent}
            <!-- <ReportDefEditor {id}/> -->
            <ReportDefForm 
              on:changed={() => saveIt()}
              bind:rpt={rpt} 
              {id} />
            <br>
        {/if}

			</div>
		</div>
	</div>
</div>

<script>
  import { onMount } from 'svelte'
  import { Panel } from 'svelte-stylo'
  import { route } from '@/pager'
  import API from '@/api'
  import { ReportDef } from '@/models'
  import ReportDefForm from './ReportDefForm.svelte'

  let
    page, 
    isCurrent = false,
    id = null,
    rpt = ReportDef.empty(), 
    create = null;

  onMount(() => {
    // to make this Page visible to the router 
    page = route({page:"#report-def-page", route: "#reporte"}) ;
    console.log("DONE: mounted ReportDefPage to route '#reporte'");

    page.content = function(url, options) {
      isCurrent = false;
      id = Appl.URL.parameter(url, "id");
      console.log("ReportDefPage: page.content url=", url, id)

      if (id === 'nuevo') {
        create = true;
        rpt = ReportDef.empty()
      }

      if (id !== 'nuevo') {
        create = false;
        loadIt(id)
      }

      return this;
    }
    
    page.current = function() {
      this._current(); // call base method
      isCurrent = true;
      console.log("ReportDefPage: page.current")
      return this;
    };

    page.hidden = function() {
      isCurrent = false;
      console.log("ReportDefPage: page.hidden")
    }
  })

  async function loadIt(id) {
    try {
      rpt = await API.reportDefs.get(id);
      console.log("ReportDefEditor loaded=", rpt);
      //template = rpt.definition && rpt.definition.template_file || null;
    }
    catch (err) {
      alert("problema al cargar")
      console.log("problema al cargar", err)
    }
  }

  async function saveIt(exit) {
    try {
      let rsp = await API.reportDefs.put(id, rpt)
      if (exit && exit === 'exit')
        window.history.back();
    }
    catch (err) {
      console.log("problema al guardar", err)
      console.log("ReportDefEditor save err=", err)
    }
  }
  
  async function deleteIt() {
    try {
      let rsp = await API.reportDefs.delete(id)
      window.history.back();
    }
    catch (err) {
      console.log("problema al eliminar", err)
      console.log("ReportDefEditor delete err=", err)
    }
  }
</script>
  